import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import styles from './SidebarMenu.module.css';

/**
 * SidebarMenu component for navigation
 * @param {Object} props
 * @param {string} props.title - Title of the sidebar menu
 * @param {Array} props.items - Array of menu items with { label, path, hash } properties
 * @param {string} props.currentPath - Current path for highlighting active item
 * @param {string} props.activeSection - Current active section based on scroll position
 * @param {function} props.onItemClick - Optional callback when item is clicked
 */
const SidebarMenu = ({ title = "", items, currentPath, activeSection, onItemClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (item) => {
    if (onItemClick) {
      onItemClick(item);
    }

    // Close menu on mobile after clicking
    if (window.innerWidth < 800) {
      setIsOpen(false);
    }
  };

  const isSamePage = (item) => {
    return item.path === window.location.pathname;
  };

  const getFullPath = (item) => {
    return item.hash ? `${item.path}${item.hash}` : item.path;
  };

  const isActive = (item) => {
    // If we have an activeSection (scroll-based), use that for highlighting
    if (activeSection && item.hash) {
      const sectionId = item.hash.substring(1); // Remove the '#'
      return window.location.pathname === item.path && sectionId === activeSection;
    }
    
    // Fallback to URL-based highlighting
    return window.location.pathname === item.path &&
      (!item.hash || window.location.hash === item.hash);
  };

  return (
    <div className={styles.sidebarContainer}>
      {/* Mobile toggle button disabled for now */}
      {/* <button
        className={styles.mobileToggle}
        onClick={toggleMenu}
        aria-label={isOpen ? "Close menu" : "Open menu"}
      >
        {isOpen ? <FaTimes /> : <FaBars />}
        {title && <span className={styles.mobileTitle}>{title}</span>}
      </button> */}

      {/* Desktop sidebar content */}
      <div className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
        {title && <div className={styles.sidebarTitle}>{title}</div>}

        <nav className={styles.menuItems}>
          <ul>
            {items.map((item, index) => (
              <li key={index} className={isActive(item) ? styles.active : ''}>
                {isSamePage(item) && item.hash ? (
                  <a
                    href={item.hash}
                    onClick={() => handleItemClick(item)}
                    className={styles.menuLink}
                  >
                    {item.label}
                  </a>
                ) : (
                  <Link
                    to={getFullPath(item)}
                    onClick={() => handleItemClick(item)}
                    className={styles.menuLink}
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default SidebarMenu;
